import { render, staticRenderFns } from "./Login_bayrakli.vue?vue&type=template&id=7f20e794"
import script from "./Login_bayrakli.vue?vue&type=script&lang=js"
export * from "./Login_bayrakli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports